import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// /oireachtas/my-results/:name (older links and emails): the family's results
// are now the My Results tab of the Oireachtas results page (MC2 card
// f157ed22), so this address forwards there.
const OireachtasMyResults = () => {
  const navigate = useNavigate();
  const { name } = useParams();
  const location = useLocation();
  useEffect(() => {
    const id = new URLSearchParams(location.search).get("id") || "";
    navigate(`/oireachtas/results/${name || "event"}?id=${id}&tab=mine`, { replace: true });
  }, [navigate, name, location.search]);
  return null;
};

export default OireachtasMyResults;
